<template>
  <div class="row m-0">
    <div class="col-12 col-md-6">
      <span
        class="bg-warning text-white invoice__badge"
        v-if="invoice.cancelledAt"
      >
        Cancelled
      </span>
      <span
        class="bg-success text-white invoice__badge"
        v-else-if="invoice.paidAt"
      >
        &#10003; Paid {{ paymentMethod }}
      </span>
      <span class="bg-warning text-white invoice__badge" v-else>
        Unpaid
      </span>
      <br />
      <br />
    </div>
    <div class="col-12 col-md-6 text-right space-x-1.25">
      <ActionButton
        class="mt-0 d-inline-block"
        style="width: auto;"
        mode="outline"
        label="Back"
        :theme="{ primary, secondary, danger, event }"
        v-if="$route.name == 'admin-invoice' && getReportHistory() === 1"
        @customEvent="handleToReports"
      />
      <ActionButton
        class="mt-0 d-inline-block"
        style="width: auto;"
        :theme="{ primary, secondary, danger, event }"
        label="Print"
        @customEvent="handlePrintClick"
      >
        <i class="fa fa-print mr-5"></i>
      </ActionButton>
      <ActionButton
        v-if="!invoice.paidAt && !invoice.cancelledAt"
        class="mt-0 d-inline-block"
        style="width: auto;"
        :theme="{ primary, secondary, danger, event }"
        label="Payment"
        @customEvent="handleOpen"
      >
        <i class="fa fa-paypal mr-5"></i>
      </ActionButton>
      <button
        v-if="!invoice.cancelledAt && !invoice.paidAt"
        class="btn btn-danger"
        style="padding: 8px 14px; font-size: 0.875rem"
        @click="handleCancelInvoice(invoice.id, invoice.code)"
      >
        <i class="fa fa-remove mr-5"></i>
        Cancel Invoice
      </button>
    </div>
    <InvoicePayment
      v-if="showPayment"
      @close="handleClose"
      @reinit="handleReinit"
      :invoice="invoice"
      scope="setting"
    />
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import InvoicePayment from "./InvoicePayment";
import _ from "lodash";
import axios from "@/helpers/axios";
import { dateToday } from "@/helpers/date";
import { socketSender } from "@/helpers/socket";
import {
  bookingCancelEmail,
  bookingCancelEmailToOwner
} from "@/helpers/mailer";
import { mapGetters } from "vuex";

export default {
  props: {
    invoice: { type: [Object], default: null }
  },
  data() {
    return {
      showPayment: false,
      currentUser:
        this.$store.getters.getUser.firstName +
        " " +
        this.$store.getters.getUser.lastName
    };
  },
  computed: {
    paymentMethod() {
      const paymentMethod = _.find(this.invoice.OrderMeta, {
        key: "paymentMethod"
      });
      if (paymentMethod) {
        return " via " + paymentMethod.value;
      }
      return "";
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  components: {
    InvoicePayment,
    ActionButton
  },
  methods: {
    ...mapGetters({
      getReportHistory: "getReportHistory"
    }),
    handlePrintClick() {
      window.print();
    },
    handleOpen() {
      this.showPayment = true;
    },
    handleClose() {
      this.showPayment = false;
    },
    handleReinit() {
      this.$emit("reinit");
    },
    async handleCancelInvoice(id, code) {
      await this.$swal({
        title: "Are you sure you want to cancel this order?",
        text: code,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#e15a4e",
        cancelButtonText: "No",
        reverseButtons: true
      }).then(async result => {
        if (result.value) {
          /**
           * SOCKET: Invoice/Order cancel log
           */
          let message = `${code} has been cancelled by ${this.currentUser}`;
          socketSender("cancelOrder", message);
          await axios
            .patch("/orders/" + id, {
              cancelledAt: dateToday()
            })
            .then(() => {
              this.$emit("reinit");
            });
          let specRecord = await axios.get(`/orders/${id}`).then(result => {
            return result.status == 200 ? result.data.data : [];
          });
          bookingCancelEmail({
            to: specRecord.User.email,
            displayName: specRecord.User.displayName,
            order: specRecord
          });

          bookingCancelEmailToOwner({
            fullName:
              specRecord.User.firstName + " " + specRecord.User.lastName,
            order: specRecord
          });
        }
      });

      this.$store.dispatch("GET_TOTAL_BOOKINGS_TODAY");
    },
    toMember() {
      this.$router.push("/admin/members");
    },
    handleToReports() {
      this.$router.push("/admin/reports");
    }
  }
};
</script>

<style lang="scss" scoped>
.invoice {
  &__badge {
    min-width: 100px;
    border-radius: 5px;
    padding: 8px 25px;
    font-size: $font-size-base;
  }
  &__modal {
    background: black;
  }
}
.btn-back {
  border: 1px solid var(--primary);
  border-radius: 0.3125rem;
  color: var(--primary);
  display: inline-block;
  font-family: $headings-font-family;
  font-size: $font-size-sm;
  height: 2.1875rem;
  line-height: 1rem;
  padding: 0.5rem 0.875rem;
  transition-property: background-color, border-color, color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  &:hover {
    background-color: var(--event);
    border-color: var(--event);
    color: white;
    text-decoration: none;
  }
}
</style>
